import { ButtonComponent } from '@/shared/components/button/button.component';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-cookies',
  templateUrl: './cookies.component.html',
  styleUrls: ['./cookies.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [TranslateModule, ButtonComponent],
})
export class CookiesComponent implements OnInit {
  /** Name of cookie that stores value */
  readonly cookiesAllowed = 'cookiesAllowed';

  constructor(public dialogRef: MatDialogRef<CookiesComponent>) {}

  ngOnInit() {
    this.checkCookiesAccepted();
  }

  /**
   * If user has accepted Cookies
   */
  onCookiesAccepted() {
    this.dialogRef.close();

    // add Cookie
    document.cookie = this.cookiesAllowed + '=true';
  }

  /**
   * Check if cookies have been accepted
   */
  checkCookiesAccepted() {
    const cookiesAccepted = this.getCookieByName(this.cookiesAllowed);

    if (cookiesAccepted) {
      this.dialogRef.close();
    }
  }

  getCookieByName(cname: string) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return false;
  }

  openLegalNotice() {
    window.open('/documents/Mentions%20légales%20-%20GNVERT.pdf', '_blank');
  }
}
